<script setup>
    // Vue
    import { defineEmits, defineExpose, inject, ref } from 'vue';

    // Store
    import { useLineFriendStore } from '@/stores/modal/lineFriendComponentStore';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // 親画面から取得したAPIのドメイン部を管理する。
    const API_URL = ref('');

    // ----------------------------
    // LINEフレンド追加
    // ----------------------------
    const lineFriendStore = useLineFriendStore();

    /**
     * LINEフレンド追加情報取得処理
     * @param API_URL
     * @param queryParam
     * @returns なし
     */
    async function getLineFriend(API_URL, queryParam) {
        // ラインタグ情報取得APIをコールする。
        const response = await lineFriendStore.getLineFriendAction(API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // 親側実装必須処理
    // ----------------------------
    const emit = defineEmits(['lineFriendModal:close']);
    function close() {
        // 親画面のクローズ処理を呼び出す
        emit('lineFriendModal:close');
    }

    /**
     * 親画面からLINE友だち追加モーダルを開くイベントが実行された場合の処理。
     * @param {String} trg HTMLファイルタグが生成されている座標を取得する。
     * @param {String} lang 言語
     * @returns なし
     */
    async function openModal(trg, lang) {
        // Storeを初期化する。
        lineFriendStore.reset();

        // APIのURL情報を取得する。
        API_URL.value = trg;

        // ラインタグ情報取得APIのクエリパラメーターを生成する。
        const queryParam = {
            Lang: lang,
        };

        // ラインタグ情報取得APIをコールする。
        await getLineFriend(API_URL.value, queryParam);
    }
    defineExpose({
        openModal,
    });
</script>

<style></style>

<template>
    <article id="modalLineFriendAdd" class="modal small" style="top: calc(50% - 180px); padding-top: 10px; display: block">
        <h3>{{ $t('lineFriend.parts.modalTitle1') }}</h3>
        <section class="modalContents" style="margin-bottom: 30px">
            <div id="qrcode" v-html="lineFriendStore.lineTag"></div>
            <p class="pageInfo" style="font-size: 14px; text-align: center">{{ $t('lineFriend.parts.modalInformation1') }}</p>
        </section>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <!--閉じる-->
                    <button type="button" class="btnNormal" @click="close">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
